import React from 'react';
import * as R from 'ramda';
import { Carousel } from '@cowsquare/design';

export const Advertisements = ({ ads = [], itemProps = {} }) => (
  <Carousel>
    {R.pipe(
      R.map(ad => (
        <Carousel.Slide
          key={ad.id}
          href={ad.link}
          title={ad.title}
          description={ad.description}
          backgroundImage={`url(${R.pathOr('', ['file', 'link'])(ad)})`}
          height="150px"
          {...itemProps}
        />
      ))
    )(ads)}
  </Carousel>
);
